import PropTypes from 'prop-types';

const photosWithDuplicatesShape = {
  key: PropTypes.string.isRequired,
  md5: PropTypes.string.isRequired,
  imageId: PropTypes.number.isRequired,
  duplicateImageIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export { photosWithDuplicatesShape };
